import { z } from 'zod';
/**
 * Server-afgeleide modulezichtbaarheid voor de frontend-sidebar (issue #38).
 * `true` = module tonen. Menu-items zonder feature-koppeling zijn altijd
 * zichtbaar; rolgebaseerde zichtbaarheid (`allowed`) blijft een aparte,
 * strengere poort die hiernaast geldt. Afleiding gebeurt op één plek in de
 * backend (config/features.ts) zodat sidebar en route-gates nooit uit elkaar
 * lopen.
 */
export const FeatureFlagsSchema = z.object({
    uren: z.boolean(),
    sara: z.boolean(),
    elearnings: z.boolean(),
    incidentMelden: z.boolean(),
    declaraties: z.boolean(),
    documenten: z.boolean(),
    handigeLinks: z.boolean(),
});
//# sourceMappingURL=features.js.map